<template>
  <div class="flex items-center">
    <!-- <vs-avatar :src="params.value" class="flex-shrink-0 mr-2" size="30px" /> -->
    <a href="javascript:void(0)" @click="chatDetails">{{params.value}}</a>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
  },
  methods: {
    chatDetails(){
      //console.log(this.params.data)
      this.$router
        .push({
          name: "Chat",
          params: {
            roomObj: {
              id: this.params.data.roomId,
              name: this.params.data.roomName,
              iconUrl: null
            }
          }
        })
        .catch(() => {});
    }
  }
}
</script>
